import React from 'react';
import { styled } from '@mui/material/styles';
import MuiSelect, { type SelectProps } from '@mui/material/Select';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import MenuItem from '@mui/material/MenuItem';

interface Props extends SelectProps {
  readonly items: SelectOption[];
  readonly legacyMode?: boolean;
}

export interface SelectOption {
  name: string;
  id: string;
}
const StyledMuiSelect = styled(MuiSelect, {
  shouldForwardProp: (prop) => prop !== 'legacyMode',
})<{ legacyMode?: boolean }>(({ legacyMode }) => (
  legacyMode
    ? {
      top: '8px',
      bottom: '8px',
      width: '35%',
      border: '1px solid #d4d4d4',
      borderRadius: '5px',
      fontSize: '14px',
    }
    : {}
));

const StyledMenuItem = styled(MenuItem, {
  shouldForwardProp: (prop) => prop !== 'legacyMode',
})<{ legacyMode?: boolean }>(({ legacyMode }) => (
  legacyMode
    ? {
      fontSize: '14px',
      ':focus': {
        backgroundColor: '#4baef8',
        color: '#fff',
      },
      ':hover': {
        backgroundColor: '#4baef8',
        color: '#fff',
      },
    }
    : {}
));

export default function BasicSelect({ items, legacyMode, ...props }: Props) {
  return (
    <StyledMuiSelect
      displayEmpty
      legacyMode={legacyMode}
      {
        ...legacyMode ? {
          disableUnderline: true,
          variant: 'standard',
          IconComponent: KeyboardArrowDownIcon,
        } : {}
      }
      data-testid="select-input"
      id={`select-${props.id}`}
      inputProps={legacyMode ? { sx: { padding: '4px' } } : {}}
      {...props}
    >
      {items.map((item) => (
        <StyledMenuItem legacyMode={legacyMode} key={item.id} value={item.id}>{item.name}</StyledMenuItem>
      ))}
    </StyledMuiSelect>
  );
}
